import {styled, Breakpoints} from '@vw-marketing/us-components';

export const StyledReviewsPreviewWrapper: any = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
`;

export const StyledModelCardWrapper: any = styled.div`
  width: 100%;
  @media (min-width: ${Breakpoints.b560}px) {
    width: 25%;
    margin-right: 40px;
  }
`;

export const StyledCarouselWrapper: any = styled.div`
  width: 100%;
`;
